module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-banner-17d13e1c68cd18311f0d84c2b19ae0dc.jpg";